module.exports = __webpack_public_path__ + "static/media/giorgio-armani-aqua-di-gioa-profumo.c8f614e2.png";